export function getErrorsMessages({ data: { errors } }) {
    return Array.from(new Set(errors.map((error) => error.message.nl)));
}
